import { render } from "./CustomerInquiries.vue?vue&type=template&id=26b11ca3&scoped=true"
import script from "./CustomerInquiries.vue?vue&type=script&lang=js"
export * from "./CustomerInquiries.vue?vue&type=script&lang=js"

import "./CustomerInquiries.vue?vue&type=style&index=0&id=26b11ca3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26b11ca3"

export default script